import { useState } from "react";
import { X } from "lucide-react";

const PHASES = [
  { t: "Evaluamos", d: "6 pilares, escala 1–4, por categoría de compra" },
  { t: "Desarrollamos", d: "camino de mejora y plan de desarrollo visible" },
  { t: "Evolucionamos", d: "tendencia histórica y seguimiento continuo" },
  { t: "Reconocemos", d: "Platino · Oro · Plata · Bronce" },
];

export default function WelcomePanel() {
  const [hidden, setHidden] = useState(localStorage.getItem("lala_welcome_v1") === "1");
  if (hidden) return null;
  return (
    <div className="sketch-border p-5 mb-8 relative" data-testid="welcome-panel">
      <button onClick={() => { localStorage.setItem("lala_welcome_v1", "1"); setHidden(true); }}
        className="absolute top-3 right-3 p-1 rounded text-[var(--ink-soft)] hover:bg-[var(--cream-deep)]" data-testid="welcome-panel-close" aria-label="Cerrar">
        <X size={15} />
      </button>
      <div className="font-hand text-lg text-[var(--ink)]">el ciclo LALA Elite</div>
      <div className="flex flex-wrap items-center gap-2 mt-2">
        {PHASES.map((p, i) => (
          <div key={p.t} className="flex items-center gap-2">
            <div className="bg-[var(--cream-soft)] rounded-xl px-4 py-2" data-testid={`welcome-phase-${i + 1}`}>
              <div className="font-display text-lg leading-tight text-[var(--ink)]">{p.t}</div>
              <div className="text-[11px] text-[var(--ink-soft)] leading-snug">{p.d}</div>
            </div>
            {i < PHASES.length - 1 && <span className="font-display text-xl text-[var(--ink-soft)]">→</span>}
          </div>
        ))}
      </div>
      <p className="text-xs text-[var(--ink-soft)] mt-2.5">
        No solo clasificamos proveedores: los ayudamos a mejorar de forma visible y continua — sin sorpresas de fin de año.
      </p>
    </div>
  );
}
